import { useNavigate } from 'react-router-dom';
import { auth } from '../api/client';

/**
 * Landing page for a signed-in staff member. Staff-facing features will live here;
 * for now it confirms the session and offers password change / sign out.
 */
export function StaffHomePage() {
  const nav = useNavigate();
  const user = auth.getUser();

  function logout() { auth.clear(); nav('/login'); }

  return (
    <>
      <header className="topbar">
        <div className="brand">Exam App · Staff</div>
        <div className="row" style={{ gap: 12 }}>
          <span style={{ fontSize: 13 }}>{user?.fullName}{user?.staffRoleName ? ` · ${user.staffRoleName}` : ''}</span>
          <button onClick={logout} className="topbar-ghost">Sign out</button>
        </div>
      </header>
      <div className="container">
        <div className="card">
          <h1 style={{ marginTop: 0 }}>Welcome, {user?.fullName}</h1>
          <div className="muted">
            You are signed in as <strong>{user?.staffRoleName ?? 'Staff'}</strong>. Staff features
            will appear here soon.
          </div>
        </div>
      </div>
    </>
  );
}
